// extracted by mini-css-extract-plugin
module.exports = {"title":"SearchResults_title__Epqer","people":"SearchResults_people__ApkZM","loader":"SearchResults_loader__L3BtA"};